import { BehaviorSubject } from 'rxjs';
import { QueryParamService } from '../../shared/util/query-params.service';

const currentPath = new BehaviorSubject<string>('');

export const setCurrentPath = (path: string) => {
  currentPath.next(path);
};

export const getCurrentPath = () => {
  return currentPath.getValue() ?? '';
};

export const addToQueryPathString = (path: string) => {
  return getCurrentPath() + '/' + path;
};

export const addToQueryPath = (path: string, service: QueryParamService) => {
  updateQueryPath(addToQueryPathString(path), service);
};

export const removeFromQueryPathString = () => {
  const stringArray = getCurrentPath().split('/');
  stringArray?.pop();
  return stringArray?.join('/');
};

export const removeFromQueryPath = (service: QueryParamService) => {
  const newPath = removeFromQueryPathString();
  if (newPath.length >= 1) {
    updateQueryPath(newPath, service);
  } else {
    deleteQueryPath(service);
  }
};

export const updateQueryPath = (path: string, service: QueryParamService) => {
  service.addQueryParam('path', path);
};

export const deleteQueryPath = (service: QueryParamService) => {
  service.removeQueryParam('path');
};
